import {getContent, initContent} from '@/services/content/content';
import eventMessagesService from '@/services/events/eventMessagesService';
import swCacheService from '@/services/swCacheService';
import {
    setDeviceType,
    setInitialGuideItemType,
    setInitialized,
    setIsDeepLinkEntry,
    setIsEmbedded,
    setLanguageCode,
    setMarketCode,
    setTipsType,
} from '@/state/slices/appSlice';
import {dispatch} from '@/state/store';

const isLastAppVersion = async () => {
    if (import.meta.env.DEV) return true;

    try {
        if ('serviceWorker' in navigator) {
            // Wait for the active service worker to be ready
            const reg = await navigator.serviceWorker.ready;

            // Force a check for service worker updates on the server
            await reg.update();

            // Check if there is a new worker waiting or currently installing
            const newWorker = reg.waiting || reg.installing;

            if (newWorker) {
                // Setup a listener to reload only when the new worker takes control
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    window.location.reload();
                });

                // Signal the new worker to skip the waiting phase and activate immediately
                newWorker.postMessage({type: 'SKIP_WAITING'});
                return false;
            }
        }
    } catch (_e) {
        //ignoring update
    }

    // If no updates are found or already applied, notify the parent app that the iframe is ready
    return true;
};

export const proceedAppInit = async (payload: any) => {
    try {
        const lastAppVersion = await isLastAppVersion();

        if (!lastAppVersion) return;

        const {
            marketCode,
            languageCode,
            deviceType,
            type,
            initialGuideItemType,
            isEmbedded = false,
            isDeepLinkEntry = false,
        } = payload || {};

        if (!marketCode || !languageCode || !deviceType || !type) {
            eventMessagesService.sendModuleInitializationError(
                `Initialized data is not correct. MarketCode: ${marketCode} LanguageCode: ${languageCode} DeviceType: ${deviceType} type: ${type}`
            );
            return;
        }

        await initContent(marketCode, languageCode);

        dispatch(setMarketCode(marketCode));
        dispatch(setLanguageCode(languageCode));
        dispatch(setDeviceType(deviceType));
        dispatch(setTipsType(type));
        dispatch(setIsEmbedded(Boolean(isEmbedded)));
        dispatch(setIsDeepLinkEntry(Boolean(isDeepLinkEntry)));

        if (initialGuideItemType) {
            dispatch(setInitialGuideItemType(initialGuideItemType));
        }

        swCacheService.warmImageCache(getContent());

        dispatch(setInitialized(true));
        eventMessagesService.sendDataSuccessReceivedMessage();
    } catch (e: unknown) {
        // @ts-expect-error
        eventMessagesService.sendModuleInitializationError(e.message);
    }
};
